import React from 'react'
import FilterTag from './FilterTag'
import { useStore } from 'src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Store/useStore'
import Search from 'src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Components/Search'
import FilterTagSelect from 'src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Components/FilterTagSelect'

/**
 * Overrides 'src/Packages/Plugins/TechDivision.Journal/Resources/Private/App/Components/Filters.js'
 * The override is registered at /overwriteMapping.js and replaces the original file completely
 */
const Filters = ({ className }) => {
    const isFilterLogicOr = useStore((state) => state.isFilterLogicOr)
    const availableFilters = useStore((state) => state.availableFilters)()
    const initiallyAvailableFilters = useStore((state) => state.initiallyAvailableFilters)()
    const activeFilterTagUids = useStore((state) => state.activeFilterTagUids)
    const currentSearchTerm = useStore((state) => state.currentSearchTerm)
    const resetFilterState = useStore((state) => state.resetFilterState)
    const translations = useStore((state) => state.translations)
    const allJournals = useStore((state) => state.allJournals)
    const hideJournalFilterHeadlines = useStore((state) => state.hideJournalFilterHeadlines)

    const getResetFilter = () => {
        const state = activeFilterTagUids.length <= 0 && currentSearchTerm === ''
        return (
            <button className="journal-list__filter-item reset" onClick={() => resetFilterState()} aria-pressed={state}>
                <input type={'checkbox'} checked={state} readOnly={true} />
                <span className="journal-list__filter-item-name">{translations.all}</span>
                <span className={'journal-list__filter-item-count'}>({allJournals.length})</span>
            </button>
        )
    }

    const getAvailableFilters = () => {
        if (isFilterLogicOr && currentSearchTerm === '') {
            return initiallyAvailableFilters
        } else {
            return availableFilters
        }
    }

    const hideSearchbar = useStore((state) => state.hideSearchbar)

    return (
        <div className="journal-list__filter-list">
            {!hideSearchbar ? <Search /> : false}
            <div className={className + ' filters-desktop'}>
                {getResetFilter()}
                {getAvailableFilters().map((category, categoryIndex) => {
                    return (
                        <div
                            className={
                                category.name.toLowerCase() === 'date'
                                    ? 'journal-list__filter-group--date'
                                    : ' journal-list__filter-group journal-list__filter-group--' +
                                      category.name.toLowerCase()
                            }
                            key={categoryIndex}
                        >
                            {hideJournalFilterHeadlines ? (
                                ''
                            ) : (
                                <h3 className={'journal-list__filter-group--headline'}>{category.description}</h3>
                            )}
                            <div className="journal-list__filter-group--header">{category.name}</div>
                            {category.tags.map((filter) => (
                                <FilterTag filter={filter} key={filter.uid} />
                            ))}
                        </div>
                    )
                })}
            </div>

            <div className={className + ' filters-mobile'}>
                {getResetFilter()}
                {getAvailableFilters().map((category) => {
                    return (
                        <div
                            className={
                                'journal-list__filter-select-wrapper journal-list__filter-group journal-list__filter-group--' +
                                category.name.toLowerCase()
                            }
                            key={category.name}
                        >
                            <FilterTagSelect category={category} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Filters
